import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue';
import { message, loader } from '@/libs/helper';
import { getUserGitInfo, deleteUserGitInfo, addUserGitInfo } from '@/libs/api/api';
import constants from '@/libs/constant/constants';
import { isEmpty } from 'lodash';
export default {
    components:{
        SettingsDropdown,
    },
    data() {
        return {
            isEmpty,
            publisherForm: {
                remoteLocation: '',
                git_repo: '',
                git_username: '',
                git_userpass: '',
                aws_accessKeyId: '',
                aws_secretAccessKey: '',
                aws_bucketName: '',
                git_branch: '',
                uploadOnAWS: true,
            },
            searchValue: '',
            columns: ['remoteLocation', 'git_repo', 'aws_bucketName', 'git_branch', 'git_username', 'settings'],
            rolesTableData: [],
            rolesTableSettings: {
                headings: {
                    remoteLocation: 'Remote Location',
                    git_repo: 'Repository',
                    aws_bucketName: 'Bucket Name',
                    git_branch: 'Branch Name',
                    git_username: 'Username'
                },
                pagination: { show: true},
                perPage: '25',
                filterable: [],
                filterByColumn: true,
                sortable: ['yes'],
                perPageValues:[]
            },
            selectedEntries: [],
            sort: 'name',
            order: 'asc',
            limit: 25,
            currentPage: 1,
            skip: 0,
            previousPage : 1,
            pageSize: '10',
            tableDataCount: null,
            isBulkEdit: false,
            selectedRoleNames: [],
            isRemoveRole: false,
            isModify: false,
            modifyMode: 'add'
        }
    },
    async mounted() {
        this.getUserGitInfo()
    },
    computed: {
        perPageSelect: {
            get(){
                return this.pageSize
            },
            set(val){
                this.pageSize = val
                this.skip=0
                this.currentPage = 1
            }
        },
        params() {
            return `?skip=${this.skip}&limit=${this.pageSize}&sort=${this.sort}&order=${this.order}`
        }
    },
    methods: {
        async addPublishSettings() {
            loader(this, true)
            await addUserGitInfo(this.publisherForm)
            .then(() => {
                this.closeModifyModal()
                loader(this, false)
                message(this, constants.messageType.SUCCESS, ('Repository details added successfully'))
                this.getUserGitInfo()
            })
            .catch((error) => {
                loader(this, false)
                message(this, constants.messageType.ERROR, (error.message))
            })
        },
        openModifyModal(mode) {
            this.isModify = true
            this.modifyMode = mode
        },
        closeModifyModal() {
            this.isModify = false
            this.publisherForm= {
                remoteLocation: '',
                repoLink: '',
                username: '',
                password: '',
                accessKeyId: '',
                secretAccessKey: '',
                bucketName: '',
                branch: '',
                uploadOnAWS: true,
            }
        },
        async getUserGitInfo() {
            loader(this, true)
            await getUserGitInfo().then((res) => {
                this.rolesTableData = res
                loader(this, false)
            }).catch((err) => {
                loader(this, false)
                console.log(err)})
        },
        async querySearch (query, cb) {
            if(query === undefined || query === '' || query.length < 2){
                return
            }
            let searchResult = []
            // call callback function to return suggestion objects
            cb(searchResult);
        },
        handleSelectValue(val) {
            this.searchValue = val.name || val.value
        },
        async clearSearchInput() {
            this.searchValue = ''
            this.skip = 0
            this.currentPage = 1
        },
        handleCommand(command, data) {
            switch (command) {
                case 'DELETE':
                    this.deleteRow(data)
                    break
                case 'VIEW':
                    this.viewRow(data)
                    break
                    
            }
        },
        async deleteRow(group) {
            const mainTitle = `${window.i18next.t(`Remove Publish Settings`)} `;
            const nameTitle = `${group.git_repo}`;
            // html for popup
            const html =
                `<div class="remove-body remove-people">
                    <div class="popup-title remove-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container remove-warning">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            ${window.i18next.t('When you remove publish settings, you can no longer push created articles to it')}.
                        </div>
                    </div>
                    <div class="warning-confirmation-text remove-warn">
                        ${window.i18next.t('Are you sure you would like to remove the publish settings, it can not be undone')}?
                    </div>                    
                </div>`
                this.$confirm(`${html}`, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: window.i18next.t('Remove'),
                    cancelButtonText: window.i18next.t('Cancel'),
                    showClose: false,
                    closeOnClickModal: false,
                    customClass: 'remove-team-popup',
                    confirmButtonClass: 'primary-button confirm mini-button',
                    cancelButtonClass: 'primary-button mini-button'
                }).then(() => {
                    // call api of delete 
                    loader(this, true)
                    deleteUserGitInfo(group._id).then(async (res) => {
                        message(this, constants.messageType.SUCCESS, (res.message))
                        loader(this, false)
                        this.getUserGitInfo()
                    }).catch((error) => {
                        loader(this, false)
                        message(this, constants.messageType.ERROR, (error.message))
                    })
                }).catch(() => {})
        },
        viewRow(data) {
            this.publisherForm.remoteLocation = data.remoteLocation
            this.publisherForm.git_repo = data.git_repo
            this.publisherForm.git_username = data.git_username
            this.publisherForm.git_userpass = data.git_userpass
            this.publisherForm.aws_accessKeyId = data.aws_accessKeyId
            this.publisherForm.aws_secretAccessKey = data.aws_secretAccessKey
            this.publisherForm.aws_bucketName = data.aws_bucketName
            this.publisherForm.git_branch = data.git_branch
            this.publisherForm.uploadOnAWS = data.uploadOnAWS
            this.openModifyModal('view')
        },
        changeSort(sortingKey) {
            this.sortingOrder = this.sortingKey !== sortingKey ? 'desc' : this.sortingOrder === 'desc' ? 'asc' : 'desc'
            this.sortingKey = sortingKey
            this.sorting(this.sortingOrder, this.sortingKey)
        },
        sorting(order, sort) {
            // this.skip = 0
            this.order = order
            // this.currentPage = 1
            this.sort = sort
        },
        changePage (currentPage) {
            this.previousPage = this.currentPage
            this.currentPage = currentPage
            // this.skip = (currentPage - 1) * this.selectedValue
            this.skip = (currentPage - 1) * this.pageSize
        },
    }
}